import { SWRFetcher } from '@commenda/utils';
import { Prisma } from '@prisma/client';
import useSWR, { KeyedMutator } from 'swr';
import { CAFirmAdditionalInformation } from './types';

type CAFirmDetails = Omit<
  Prisma.CAFirmGetPayload<{
    include: {
      workRequests: {
        include: {
          complianceItem: true;
          company: {
            select: {
              companyDisplayName: true;
            };
          };
          corporation: {
            select: {
              companyLegalName: true;
            };
          };
          accountantLinks: true;
          statusTransitions: true;
        };
      };
      corporationHasCAFirm: {
        include: {
          caFirm: true;
          corporation: {
            include: {
              company: true;
            };
          };
        };
      };
      users: {
        include: {
          caFirm: true;
          user: true;
        };
      };
    };
  }>,
  'additionalInformation'
> & {
  additionalInformation: CAFirmAdditionalInformation;
  meetingLinkPath: string | null;
};

function useCAFirm({ token, caFirmId }: { token?: string; caFirmId: string }) {
  const {
    data,
    error,
    mutate,
  }: {
    data?: CAFirmDetails;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    caFirmId ? `caFirm/${caFirmId}` : null,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    )
  );

  return {
    data,
    error,
    mutate,
  };
}

export { useCAFirm };
export type { CAFirmDetails };
